import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MbEmptyCartComponent } from './mb-empty-cart.component'
import { ConfigModule } from '@spartacus/core'
import { MbI18nModule } from '../../../translations/mb-i18n.module'
import { RouterLink } from '@angular/router'
import { LinkModule } from '../../../cms/components/shared/link/link.module'

@NgModule({
    imports: [
        ConfigModule.withConfig({
            cmsComponents: {
                MiltenyiEmptyCartComponent: {
                    component: MbEmptyCartComponent
                }
            }
        }),
        CommonModule,
        MbI18nModule,
        RouterLink,
        LinkModule
    ],
  providers: [],
  declarations: [MbEmptyCartComponent]
})
export class MbEmptyCartModule {
}
